import axios from "axios";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API } from "../../helpers/constants";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../helpers/errorHandling";
import { CHECKLISTS } from "../../locales/pages/namespaces";
import useUserAction from "../user/useUserAction";
import useUserData from "../user/useUserData";

const useCheckLists = () => {
	const { t } = useTranslation(CHECKLISTS)
	const { token, username, userId, isLoggedIn, dateFormat, timeFormat } = useUserData()
	const { userLogout } = useUserAction()
	const [checkList, setCheckList] = useState(null)
	const [site, setSite] = useState(null)
	const [loading, setLoading] = useState(true)
	
	useEffect(() => {
		axios({
			method: 'post',
			url: `${API}/en/custom/goodtohave/edit`,
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
		}).then((res) => {
			const site = res.data?.SiteDescription && res.data.SiteDescription !== 'Not Found' ? res.data.SiteDescription : ''
			const data = res.data?.data
			if (data.length > 0) {
				const checkList = data[0]
				setCheckList({
					id: checkList.id,
					activeFromDt: checkList.ucActiveFromDt ? dayjs(checkList.ucActiveFromDt) : '',
					activeToDt: checkList.ucActiveToDt ? dayjs(checkList.ucActiveToDt) : '',
					referenceDt: checkList?.ucReferenceDt ? dayjs(checkList.ucReferenceDt) : '',
					// binTasks: checkList?.binTasks ?? '',
					// binComment: checkList?.binComment ?? '',
					// wasteCollection: checkList?.wasteCollection ?? '',
					// wasteCollectionComment: checkList?.wasteCollectionComment ?? '',
					// furniture: checkList?.furniture ?? '',
					// furnitureComment: checkList?.furnitureComment ?? '',
					// bowlsAndLids: checkList?.bowlsAndLids ?? '',
					// bowlsAndLidsComment: checkList?.bowlsAndLidsComment ?? '',
					// sweepTheFloor: checkList?.sweepTheFloor ?? '',
					// sweepTheFloorComment: checkList?.sweepTheFloorComment ?? '',
					// mopTheFloor: checkList?.mopTheFloor ?? '',
					// mopTheFloorComment: checkList?.mopTheFloorComment ?? '',
					// toiletPaper: checkList?.toiletPaper ?? '',
					// toiletPaperComment: checkList?.toiletPaperComment ?? '',
					// cleanTheSinks: checkList?.cleanTheSinks ?? '',
					// cleanTheSinksComment: checkList?.cleanTheSinksComment ?? '',
					// cleanHandDryers: checkList?.cleanHandDryers ?? '',
					// cleanHandDryersComment: checkList?.cleanHandDryersComment ?? '',
					// washTheCups: checkList?.washTheCups ?? '',
					// washTheCupsComment: checkList?.washTheCupsComment ?? '',
					// sweepTheSidewalk: checkList?.sweepTheSidewalk ?? '',
					// sweepTheSidewalkComment: checkList?.sweepTheSidewalkComment ?? '',
					// sweepElevators: checkList?.sweepElevators ?? '',
					// sweepElevatorsComment: checkList?.sweepElevatorsComment ?? '',
					// sweepFloorsWithVacuumCleaner: checkList?.sweepFloorsWithVacuumCleaner ?? '',
					// sweepFloorsWithVacuumCleanerComment: checkList?.sweepFloorsWithVacuumCleanerComment ?? '',
					// vacuumCarpetedAreas: checkList?.vacuumCarpetedAreas ?? '',
					// vacuumCarpetedAreasComment: checkList?.vacuumCarpetedAreasComment ?? '',
					// cleanFloorsWithSpecialLiquid: checkList?.cleanFloorsWithSpecialLiquid ?? '',
					// cleanFloorsWithSpecialLiquidComment: checkList?.cleanFloorsWithSpecialLiquidComment ?? '',
					// dustTheFolders: checkList?.dustTheFolders ?? '',
					// dustTheFoldersComment: checkList?.dustTheFoldersComment ?? '',
					// cleanThePhones: checkList?.cleanThePhones ?? '',
					// cleanThePhonesComment: checkList?.cleanThePhonesComment ?? '',
					// dustBookcases: checkList?.dustBookcases ?? '',
					// dustBookcasesComment: checkList?.dustBookcasesComment ?? '',
					// cleanMetals: checkList?.cleanMetals ?? '',
					// cleanMetalsComment: checkList?.cleanMetalsComment ?? '',
					// cleanEntranceDoors: checkList?.cleanEntranceDoors ?? '',
					// cleanEntranceDoorsComment: checkList?.cleanEntranceDoorsComment ?? '',
					// cleanFingerPrints: checkList?.cleanFingerPrints ?? '',
					// cleanFingerPrintsComment: checkList?.cleanFingerPrintsComment ?? '',
					// dustPlantPots: checkList?.dustPlantPots ?? '',
					// dustPlantPotsComment: checkList?.dustPlantPotsComment ?? '',
					// dustWindowSills: checkList?.dustWindowSills ?? '',
					// dustWindowSillsComment: checkList?.dustWindowSillsComment ?? '',
					// sweepAndMopStairs: checkList?.sweepAndMopStairs ?? '',
					// sweepAndMopStairsComment: checkList?.sweepAndMopStairsComment ?? '',
					// glassOfBookcasesDay1: checkList?.glassOfBookcasesDay1 ? dayjs(checkList.glassOfBookcasesDay1) : '' ,
					// glassOfBookcasesDay2: checkList?.glassOfBookcasesDay2 ? dayjs(checkList.glassOfBookcasesDay2) : '',
					// glassOfBookcasesDay3: checkList?.glassOfBookcasesDay3 ? dayjs(checkList.glassOfBookcasesDay3) : '',
					// glassOfBookcasesDay4: checkList?.glassOfBookcasesDay4 ? dayjs(checkList.glassOfBookcasesDay4) : '',
					// glassOfBookcasesComment: checkList?.glassOfBookcasesComment ?? '',
					// glossyFurnitureDay1: checkList?.glossyFurnitureDay1 ? dayjs(checkList.glossyFurnitureDay1) : '',
					// glossyFurnitureDay2: checkList?.glossyFurnitureDay2 ? dayjs(checkList.glossyFurnitureDay2) : '',
					// glossyFurnitureDay3: checkList?.glossyFurnitureDay3 ? dayjs(checkList.glossyFurnitureDay3) : '',
					// glossyFurnitureDay4 : checkList?.glossyFurnitureDay4 ? dayjs(checkList.glossyFurnitureDay4) : '',
					// glossyFurnitureComment:  checkList?.glossyFurnitureComment ?? '',
					// toiletWallsDay1: checkList?.toiletWallsDay1 ? dayjs(checkList.toiletWallsDay1) : '',
					// toiletWallsDay2: checkList?.toiletWallsDay2 ? dayjs(checkList.toiletWallsDay2) : '',
					// toiletWallsDay3: checkList?.toiletWallsDay3 ? dayjs(checkList.toiletWallsDay3) : '',
					// toiletWallsDay4: checkList?.toiletWallsDay4 ? dayjs(checkList.toiletWallsDay4) : '',
					// toiletWallsComment: checkList?.toiletWallsComment ?? '',
					// cleanPhotocopiersDay1: checkList?.cleanPhotocopiersDay1 ? dayjs(checkList.cleanPhotocopiersDay1) : '',
					// cleanPhotocopiersDay2: checkList?.cleanPhotocopiersDay2 ? dayjs(checkList.cleanPhotocopiersDay2) : '',
					// cleanPhotocopiersDay3: checkList?.cleanPhotocopiersDay3 ? dayjs(checkList.cleanPhotocopiersDay3) : '',
					// cleanPhotocopiersDay4: checkList?.cleanPhotocopiersDay4 ? dayjs(checkList.cleanPhotocopiersDay4) : '',
					// cleanPhotocopiersComment: checkList?.cleanPhotocopiersComment ?? '',
					// cleanSurroundingBuildDay1: checkList?.cleanSurroundingBuildDay1 ? dayjs(checkList.cleanSurroundingBuildDay1) : '',
					// cleanSurroundingBuildDay2: checkList?.cleanSurroundingBuildDay2 ? dayjs(checkList.cleanSurroundingBuildDay2) : '',
					// cleanSurroundingBuildDay3: checkList?.cleanSurroundingBuildDay3 ? dayjs(checkList.cleanSurroundingBuildDay3) : '',
					// cleanSurroundingBuildDay4: checkList?.cleanSurroundingBuildDay4 ? dayjs(checkList.cleanSurroundingBuildDay4) : '',
					// cleanSurroundingBuildComment: checkList?.cleanSurroundingBuildComment ?? '',
					// dustCabinetsDate: checkList?.dustCabinetsDate ?  dayjs(checkList.dustCabinetsDate) : '',
					// dustCabinetsComment: checkList?.dustCabinetsComment  ?? '',
					// wasteBasketsDate: checkList?.wasteBasketsDate ?  dayjs(checkList.wasteBasketsDate) : '',
					// wasteBasketsComment: checkList?.wasteBasketsComment  ?? '',
					// movedFurnitureDate: checkList?.movedFurnitureDate ?  dayjs(checkList.movedFurnitureDate) : '',
					// movedFurnitureComment: checkList?.movedFurnitureComment,
					// vacuumFurnitureDate: checkList?.vacuumFurnitureDate ?  dayjs(checkList.vacuumFurnitureDate) : '',
					// vacuumFurnitureComment: checkList?.vacuumFurnitureComment,
					// windowBlindsDate: checkList?.windowBlindsDate ?  dayjs(checkList.windowBlindsDate) : '',
					// windowBlindsComment: checkList?.windowBlindsComment,
					// auxiliaryAreasDate: checkList?.auxiliaryAreasDate ?   dayjs(checkList.auxiliaryAreasDate) : '',
					// auxiliaryAreasComment: checkList?.auxiliaryAreasComment,
					// glassFacadesDate: checkList?.glassFacadesDate ?   dayjs(checkList.glassFacadesDate) : '',
					// glassFacadesComment:  checkList?.glassFacadesComment,
					// wipeRoofsDate: checkList?.wipeRoofsDate ?   dayjs(checkList.wipeRoofsDate) : '',
					// wipeRoofsComment:  checkList?.wipeRoofsComment ?? '',
					// multiStoreyDate: checkList?.multiStoreyDate ?   dayjs(checkList.multiStoreyDate) : '',
					// multiStoreyComment:  checkList?.multiStoreyComment ?? '',
					// securityShuttersDate: checkList?.securityShuttersDate ?   dayjs(checkList.securityShuttersDate) : '',
					// securityShuttersComment:  checkList?.securityShuttersComment ?? '',
					// officeCarpetsDate: checkList?.officeCarpetsDate ?   dayjs(checkList.officeCarpetsDate) : '',
					// officeCarpetsComment:  checkList?.officeCarpetsComment ?? '',
					// kitchenCabinetsDate: checkList?.kitchenCabinetsDate ?   dayjs(checkList.kitchenCabinetsDate) : '',
					// kitchenCabinetsComment:  checkList?.kitchenCabinetsComment ?? '',
					// externalMarbleDate: checkList?.externalMarbleDate ?   dayjs(checkList.externalMarbleDate) : '',
					// externalMarbleComment:  checkList?.externalMarbleComment ?? '',
					// marbleFloorsDate: checkList?.marbleFloorsDate ?   dayjs(checkList.marbleFloorsDate) : '',
					// marbleFloorsComment:  checkList?.marbleFloorsComment ?? '',
					// washGlassDate: checkList?.washGlassDate ?   dayjs(checkList.washGlassDate) : '',
					// washGlassComment:  checkList?.washGlassComment ?? '',
					// specialMultiStoreyDate: checkList?.specialMultiStoreyDate ?   dayjs(checkList.specialMultiStoreyDate) : '',
					// specialMultiStoreyComment:  checkList?.specialMultiStoreyComment ?? '',
					// washSecurityShuttersDate: checkList?.washSecurityShuttersDate ?   dayjs(checkList.washSecurityShuttersDate) : '',
					// washSecurityShuttersComment:  checkList?.washSecurityShuttersComment ?? '',
					// washOfficeCarpetsDate: checkList?.washOfficeCarpetsDate ?   dayjs(checkList.washOfficeCarpetsDate) : '',
					// washOfficeCarpetsComment:  checkList?.washOfficeCarpetsComment ?? '',
					// washSeatsDate: checkList?.washSeatsDate ?   dayjs(checkList.washSeatsDate) : '',
					// washSeatsComment:  checkList?.washSeatsComment ?? '',
					// mechanicalWashingDate: checkList?.mechanicalWashingDate ?   dayjs(checkList.mechanicalWashingDate) : '',
					// mechanicalWashingComment:  checkList?.mechanicalWashingComment ?? '',
					ucDailyTasks: checkList?.ucDailyTasks ?? '',
					ucDailyComment: checkList?.ucDailyComment ?? '',
					ucWeeklyTasks: checkList?.ucWeeklyTasks ?? '',
					ucWeeklyComment: checkList?.ucWeeklyComment ?? '',
					ucMonthlyTasks: checkList?.ucMonthlyTasks ?? '',
					ucMonthlyComment: checkList?.ucMonthlyComment ?? '',
					ucTrimesterTasks: checkList?.ucTrimesterTasks ?? '',
					ucTrimesterComment: checkList?.ucTrimesterComment ?? '',
					ucMonthlyTasks2: checkList?.ucMonthlyTasks2 ?? '',
					ucMonthlyComment2: checkList?.ucMonthlyComment2 ?? '',
					ucTrimesterTasks2: checkList?.ucTrimesterTasks2 ?? '',
					ucTrimesterComment2: checkList?.ucTrimesterComment2 ?? '',
					ucYearlyTask: checkList?.ucYearlyTask ?? '',
					ucYearlyComment: checkList?.ucYearlyComment ?? '',
					ucYearlyTask2: checkList?.ucYearlyTask2 ?? '',
					ucYearlyComment2: checkList?.ucYearlyComment2 ?? '',
					signName: checkList?.ucSignName ?? '',

				})
			}
			setSite(site)
			setLoading(false)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'error',
				autoHideDuration: 3000,
			})
			setLoading(false)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}, [logoutUnauthorizedUser, token, isLoggedIn, userLogout, t]);
	
	return {
		loading,
		site,
		checkList
	}
}

export default useCheckLists